import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';

import '../css/about/news/article-wrapper.css';
import '../css/about/news/back-button.css';
import '../css/about/news/share-button.css';
import '../css/privacy-customize.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import getWordingJson from './request/wordingJson';
import wordingSetter from './wordingSetter';
import hideLoadingImage from './common/hideLoadingImage';

setup();

getWordingJson('privacy')
	.then((json) => wordingSetter(json))
	.then(() => hideLoadingImage());

/**
 * go to the previous page
 */
document.querySelector('.back-button').addEventListener('click', () => {
	window.history.back();
});



// WEBPACK FOOTER //
// ./src/js/privacy.js